module.exports = __webpack_public_path__ + "img/千年健.b95b2a04.jpg";